// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FdFjd","field":"styles_field__3alYQ","fieldCol":"styles_fieldCol__xO853","diffCol":"styles_diffCol__2l-ig","diff":"styles_diff__3uP98"};